import styled from 'styled-components';

export const FooterContainer = styled.footer`
  text-align: center;
  margin: 3rem 1rem;
  a {
    color: var(--accent);
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;
